<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Container, Text, Button, toast, Alert, Modal } from '@Shelly/shelly-design-system';
	import DoubleTimePicker from '../../../../TimePicker/DoubleTimePicker.svelte';
	import { createEventDispatcher } from 'svelte';
	import DayPicker from '../../../../TimePicker/DayPicker.svelte';
	import {
		_calculate_duration,
		validate_custom_intervals,
		real_duration_from_negative,
		_deepClone,
		capFirstChar,
	} from '../../../../../helpers/utilities';
	import { calculateWhenEnd } from 'src/helpers/interface_helpers';

	export let interval = {
			type: 'add',
			index: 0,
			isin: [0, 2, 3, 4],
			time: ['12:33', '03:03'],
		},
		intervals;

	let invalid = false; //interval.type === 'add' ? true : false;
	let alertHeading, alertType;
	let custom_days = [], //each intervals
		custom_times = []; //each intervals

	$: isValidData = !invalid && interval?.isin?.length > 0 && interval?.time?.length === 2;

	const dispatch = createEventDispatcher();

	const handle_changes = (newInterval) => {
		let active = [...newInterval.isin];
		let time = [...newInterval.time];

		let currentIntervalDuration = _calculate_duration(time);

		//First of all => validate duration for new interval;
		if (isNaN(currentIntervalDuration)) {
			invalid = true;
		} else {
			// 1. check main
			let _interval_duration =
				currentIntervalDuration < 0
					? real_duration_from_negative(currentIntervalDuration)
					: currentIntervalDuration;
			let isValid = _interval_duration > 0 && _interval_duration <= 1439 ? true : false;

			// 2. If user has custom temp intervals
			if (custom_days.length > 0) {
				isValid = validate_custom_intervals({ active, time }, { custom_days, custom_times });
			}

			invalid = !isValid;
		}

		if (invalid) {
			alertHeading = $format('alert_error_interval_overlap');
			alertType = 'danger';
		} else if (!invalid && interval.isin.length === 0) {
			invalid = !invalid;
			alertHeading = $format('alert_heading_missing_information', {
				default: 'Missing information!',
			});
			alertType = 'danger';
		} else {
			alertHeading = $format('alert_valid_interval', {
				default: 'Valid interval',
			});
			alertType = 'success';
		}
	};

	const handle_save = () => {
		if (!invalid && isValidData) {
			dispatch('save', { interval });
		}
		if (!isValidData) {
			toast.open({
				type: 'danger',
				title: $format('alert_heading_missing_information', {
					default: 'Missing information!',
				}),
			});
		}
	};

	const handle_days_changes = (e) => {
		interval.isin = e.detail;
		handle_changes(interval);
	};

	const handle_time_changes = (e) => {
		interval.time = e.detail;
		console.log('time ', interval.time);
		handle_changes(interval);
	};

	onMount(() => {
		if (intervals?.length > 0) {
			for (let i = 0; i < intervals.length; i++) {
				/** Custom intervals contain only different intervals, than the edited   */
				if (interval.index !== i) {
					//we edit the existing interval, so wi will skip it, to avoid
					// validation edited interval with its previous values
					// and push only the different intervals
					custom_days.push(
						intervals[i]?.indailyint?.dows?.split(' ')?.map((el) => Number(el) - 1),
					);
					custom_times.push([
						intervals[i]?.indailyint?.startat,
						calculateWhenEnd(
							intervals[i]?.indailyint?.startat,
							intervals[i]?.indailyint?.dur,
						),
					]);
				}
			}
			//console.log('custom ', custom_days);
		}
	});
</script>

<Modal
	on:close={() => {
		dispatch('cancel');
	}}
	title={capFirstChar($format('specific_interval'))}
	showModal
	backdropClose={false}
>
	<Container fullHeight slot="content" padding="0">
		<Text element="h2" class="mb-m">
			{$format('choose_day_of_week', { default: 'Choose day(s) of the week' })}
		</Text>
		<DayPicker class="mb-m" days={interval.isin} on:change={(e) => handle_days_changes(e)} />

		<Text element="h2" class="mb-m">
			{$format('choose_time_interval', { default: 'Choose interval' })}
		</Text>
		<DoubleTimePicker time={interval.time} on:change={(e) => handle_time_changes(e)} />

		<Alert class="mt-m" type={alertType} heading={alertHeading} isHeadingBold />
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={(e) => {
				dispatch('cancel');
			}}
		>
			{$format('button_cancel')}
		</Button>

		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			disabled={invalid}
			on:click={() => {
				handle_save();
			}}
		>
			{$format('button_save_type', {
				values: { type: $format('process_interval') },
			})}
		</Button>
	</div>
</Modal>
